import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ShopRegisterComponent from './register.component';

const shopRegisterModule = angular.module('tinaba.components.shop.register', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('shop.register', {
      url: '/register',
      template: '<shop-register></shop-register>',
    });
})
.component('shopRegister', ShopRegisterComponent);


export default shopRegisterModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/shop/register/register.js
 **/